import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import axios from 'axios';
import { injectIntl, FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import Link from '../../Link/Link';
import Button from 'react-bootstrap/lib/Button';
import withStyles from 'isomorphic-style-loader/withStyles';
import SpreadSheetComponent from '../../Common/SpreadSheetComponent/SpreadSheetComponent';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import messages from '../../../locale/jsonMessages';
import { formatMobileLanguage } from '../../../helpers/formatLocale';
import { spreadSheetExportHelper } from './Helper/spreadSheetExportHelper';
import { spreadSheetImportHelper } from './Helper/spreadSheetImportHelper';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';

import s from '../../../components/siteadmin/admin-common.css';
import c from './MobileLanguageInfo.css';
import cs from '../../../components/commonStyle.css';



function LanguageSpreadSheet(props) {
	const { languageCode, appType, isMobileLanguageRestricted } = props;
	const [loaded, setLoaded] = useState(false);
	const [rowData, setRowData] = useState({});
	const [startRows, setStartRows] = useState(null);
	const [endRows, setEndRows] = useState(null);
	const { formatMessage } = useIntl();
	const [isRestrict, setIsRestrict] = useState(false);
	const [restrictLoaded, setRestrictLoaded] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		async function fetchData() {
			const isRestrict = await dispatch(demoRestrictionEncode({}));
			if (isRestrict) {
				setIsRestrict(isRestrict);
				setRestrictLoaded(true);
			} else {
				setRestrictLoaded(true);
			}
		}
		fetchData()
	}, []);

	useEffect(() => {
		async function fetchData() {
			try {
				let inputData;
				const response = await axios.get('/get-language', {
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
					params: {
						languageCode,
						appType
					}
				});
				inputData = response?.data?.data || {};
				const data = Object.entries(inputData).map(([key, value]) => [
					{ value: key, readOnly: true },
					{ value }
				]);
				setRowData(data);
				setTimeout(() => setLoaded(true), 100);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		}
		fetchData();
	}, [languageCode, appType]);


	const handleAddRow = () => {
		const newRow = [{ value: '' }, { value: '' }];
		setRowData(prevRowData => [newRow, ...prevRowData]);
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		})
	};

	const handleSelect = (selectedRanges) => {
		if (selectedRanges && typeof selectedRanges === 'object' && 'start' in selectedRanges && 'end' in selectedRanges) {
			setStartRows(selectedRanges?.start);
			setEndRows(selectedRanges.end);
		}
	};

	const removeRow = () => {
		if (startRows != null && endRows != null) {
			const newData = rowData?.filter((_, index) => index < startRows || index > endRows);
			setRowData(newData);
			setStartRows(null);
			setEndRows(null);
		} else if (rowData?.length > 1) {
			setRowData(rowData?.slice(1));
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			})
		}
	};

	const handleSave = async () => {
		let modifiedData = {}, isEmptyData = false, inValidKey = false;
		if (isRestrict) {
			return showToaster({ messageId: 'demoWarning', toasterType: 'warning' })
		}

		for (let row = 0; row < rowData?.length; row++) {
			for (let col = 0; col < rowData[row]?.length; col++) {
				if (rowData[row]?.[col + 1]?.value !== undefined) {
					let key = rowData[row][col]?.value.toString().trim();
					let value = rowData[row][col + 1]?.value.toString().trim();
					const processed = value.replace(/\\\\/g, '\\'); // Convert double-backslashes
					value = JSON.stringify(processed);
					value = JSON.parse(value);
					if (key === '' || value === '') {
						isEmptyData = true;
						break;
					} else if (!/^[a-zA-Z0-9_]+$/i.test(key)) {
						inValidKey = true;
						break;
					} else {
						modifiedData = {
							...modifiedData,
							[key]: value
						};
					}
				}
			}
			if (isEmptyData || inValidKey) break;
		}

		if (isEmptyData || inValidKey) {
			showToaster({ messageId: isEmptyData ? 'mobileLanguageEmptyError' : 'mobileLanguageRegexError', toasterType: 'error', requestMessage: appType });
		} else {
			const params = JSON.stringify({
				data: modifiedData,
				languageCode,
				appType
			});

			try {
				const response = await axios.post('/save-language', params, {
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				});
				if (response?.status === 200) {
					showToaster({ messageId: appType === 'web' ? 'webLanguageSuccess' : 'mobileLanguageSuccess', toasterType: 'success' });
				} else {
					showToaster({ messageId: appType === 'web' ? 'webLanguageError' : 'mobileLanguageError', toasterType: 'error' });
				}
			} catch (err) {
				console.error('Save failed:', err);
				showToaster({ messageId: appType === 'web' ? 'webLanguageError' : 'mobileLanguageError', toasterType: 'error' });
			}
		}
	};


	const handleChange = (newData) => {
		setRowData(newData);
	};

	const handleExportCsv = () => spreadSheetExportHelper({ rowData, languageCode, appType, isRestrict });

	const handleImportCsv = (file) => spreadSheetImportHelper({ file, rowData, setRowData, languageCode, appType, isRestrict });


	let appNameLabel = appType === 'android_app' ? <FormattedMessage  {...messages.androidLabel} /> : appType === 'iOS_app' ? <FormattedMessage  {...messages.iosLabel} /> : (appType == 'web' ? <FormattedMessage  {...messages.webLabel} /> : <FormattedMessage  {...messages.flutterLabel} />)

	return (
		<div>
			<div className={cx(cs.displayFlex, cs.justifyContentSpaceBetween, cs.gap8, cs.spaceBottom4, cs.flexWrap, cs.alignCenter)}>
				<h3 className={cx(s.siteAdminHeading, c.noMargin)}>
					{
						appType === 'web' ? formatMessage(messages.editWebLanguage) : formatMessage(messages.editMobileLanguage)
					} ({appNameLabel})
				</h3>
				<div className={cx(cs.displayFlex, cs.gap16, cs.flexWrap)}>
					<Link to={`/siteadmin/mobile-language`} className={cx(cs.btnPrimaryBorder)}>
						<FormattedMessage  {...messages.goBack} />
					</Link>
					<Button onClick={() => handleSave()} className={cx(cs.btnPrimary)}><FormattedMessage  {...messages.save} /> </Button>
				</div>
			</div>
			<SpreadSheetComponent
				data={rowData}
				handleChange={handleChange}
				handleAddRow={handleAddRow}
				removeRow={removeRow}
				handleSave={handleSave}
				loaded={loaded}
				languageCode={languageCode}
				language={formatMobileLanguage(languageCode)}
				handleSelect={handleSelect}
				onExportCsv={handleExportCsv}
				onImportCsv={handleImportCsv}
				isMobileLanguageRestricted={isMobileLanguageRestricted}
				isRestrict={isRestrict}
				restrictLoaded={restrictLoaded}
			/>
		</div>
	)
}

export default injectIntl(withStyles(s, c, cs)(LanguageSpreadSheet));

